import { getOrCreateDirectConversation, sendSystemMessage } from './chat-service'
import { encodeLocationShareBody } from '@shared/calls/call-system-message'

export type ShareLocationInput = {
  /** The user sharing their location (the caller). */
  selfUserId: string
  selfName: string
  /** The peer the location is shared TO. */
  peerUserId: string
  peerName: string
  /** Existing direct conversation between the two parties, when known. */
  conversationId?: string | null
  location: { lat: number; lng: number; label?: string; accuracy?: number }
}

/**
 * Share the caller's live location with the call peer DURING a call.
 *
 * Posts a SYSTEM message (encoded location-share meta) into the direct thread
 * between the two parties so the entry shows up in BOTH parties' conversation /
 * activity record. The tile renders directionally per viewer ("You shared your
 * location with X" vs "X shared their location with you"). No schema/resolver
 * change is required — this rides the normal message-send path.
 */
export async function shareLocationWithPeer(input: ShareLocationInput): Promise<void> {
  let conversationId = input.conversationId ?? null
  if (!conversationId) {
    const thread = await getOrCreateDirectConversation(input.peerUserId, input.selfUserId)
    conversationId = thread.id
  }
  await sendSystemMessage(
    conversationId,
    encodeLocationShareBody({
      sharerId: input.selfUserId,
      sharerName: input.selfName,
      location: input.location,
    }),
  )
}
